
const camelize = str => str.replace(/-(\w)/g, (_, c) => (c ? c.toUpperCase() : ''));
function getPluginName(ast, name) {
  console.log('pluginName=', `$${name}${camelize(`-${ast}`)}Plugin`);
  return `$${name}${camelize(`-${ast}`)}Plugin`;
}
const openUrl = (url, target = '_self') => {
  try {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      window.location.href = url;
      return;
    }
    const newTab = window.open('', target);
    newTab.opener = null;
    newTab.location = url;
  } catch (error) {
    console.error('openUrl fail, err=', error);
    window.location.href = url;
  }
};

const openerPlugin = {
  install(Vue) {
    Vue.prototype.$opener = {
      getOpenViewSchema: async (params) => {
        if (Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'opener')] && Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'opener')].getOpenViewSchema) {
          return await Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'opener')].getOpenViewSchema(params);
        } else {
          return;
        }
      },
      openView: async (params, store) => {
        console.log('openView params=', params, store);
        if (Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'opener')] && Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'opener')].openView) {
          return await Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'opener')].openView(params, store);
        } else {
          openUrl(params.url, params.target);
        }
      }
    };
  },
};

export default openerPlugin;
